import UserContext from "../../../context/UserContext";
import { useContext } from "react";

function ContentItems(props) {
  const { isLogged, userData } = useContext(UserContext);
  const { role } = userData;
  return (
    <li>
      <div className="card bg-base-100 w-full shadow-xl flex flex-col justify-center items-center">
        <div className="flex flex-col items-center">
          <h1 className="text-2xl font-semibold">{props.name}</h1>
          {props.image && (
            <div className="my-6 ">
              <img
                src={"https://yemeni-forum-api.motaz.dev/" + props.image}
                alt=""
              />
            </div>
          )}
          <p className="text-center">{props.description}</p>
          <br />
          {props.links &&
            Array.isArray(props.links) &&
            props.links.length > 0 && (
              <>
                <hr className="w-full" />
                <div className="mt-5 grid grid-cols-3 w-full text-center">
                  {props.links.map((link, index) => {
                    return (
                      <a
                        href={link.url}
                        className="font-semibold sm:text-sm md:text-sm lg:text-lg xl:text-2xl hover:text-custom-blue"
                        key={index}
                      >
                        {link.name}
                      </a>
                    );
                  })}
                </div>
              </>
            )}
        </div>
        {isLogged && role === "admin" && (
          <div className="w-full flex justify-center gap-5 ">
            <button
              className="btn hover:bg-red-400 text-red-600 w-20"
              onClick={props.onDelete}
            >
              Delete
            </button>
            <button
              onClick={props.onStartEdit}
              className="btn text-blue-600 hover:bg-blue-400 w-20"
            >
              Edit
            </button>
          </div>
        )}
      </div>
    </li>
  );
}

export default ContentItems;
